export const SHIPMENTS_ROUTE = 'shipments';
export const SHIPMENTS_ROUTE_MY_SHIPMENTS = 'my-shipments';
export const SHIPMENTS_ROUTE_FILTER_SHIPMENTS = 'filter-shipments';
export const SHIPMENTS_ROUTE_SHIPMENT_DOCUMENT_VIEW = `${SHIPMENTS_ROUTE}/shipment-documents`;
export const SHIPMENTS_ROUTE_DASHBOARD = 'dashboard';
export const SHIPMENTS_ROUTE_MY_STATUS = 'my-status';
export const SHIPMENTS_ROUTE_DETAILS = 'details';
export const SHIPMENTS_ROUTE_STOPS_DETAILS = 'stops';
export const SHIPMENTS_HISTORY = 'shipments-history';